import 'css-chunksrc/client/scenes/strategicAxisEdition/form/colorPickerInput/styles.scss';export default {
  "form": "_form_17gfa_1",
  "iconBox": "_iconBox_17gfa_21",
  "icon": "_icon_17gfa_21",
  "group": "_group_17gfa_36",
  "input": "_input_17gfa_40",
  "colorPicker": "_colorPicker_17gfa_51"
};